import React from "react";
import { TBannerPlace } from '../../types/adfoxBanner';
import { BannersList } from '../../components/BannersList';

interface IAdvertisingListContainerProps {
  place: TBannerPlace;
}

export const AdvertisingListContainer: React.FC<IAdvertisingListContainerProps> = props => {
  const { place } = props;

  return (
    <BannersList place={place} />
  );
}
